// Scrolling images: always loop. On screens wider than the photos, repeat the photos until they fill the width.
if (!customElements.get('scrolling-images-marquee')) {
  customElements.define(
    'scrolling-images-marquee',
    class ScrollingImagesMarquee extends HTMLElement {
      connectedCallback() {
        this.tracks = this.querySelectorAll('.scrolling-images__track');
        this.track = this.tracks[0];
        if (!this.track) return;
        this.originals = Array.from(this.track.children);

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      update() {
        if (!this.originals.length) return;

        // Both rows get the same copies, so the loop stays seamless
        for (let i = 0; i < 10 && this.track.scrollWidth < this.clientWidth; i++) {
          this.tracks.forEach((track) => {
            this.originals.forEach((slide) => {
              const copy = slide.cloneNode(true);
              copy.removeAttribute('data-shopify-editor-block');
              copy.setAttribute('aria-hidden', 'true');
              track.appendChild(copy);
            });
          });
        }
      }
    }
  );
}
